import * as bgScript from '@ps/bridge/qc/scripts/bg-config'
import gameIframe from '@ps/bridge/iframe/iframe'
import store from '@ps/store'
import pathConfig from '@ps/bridge/path'

const resources = {
  bgm: {
    name: 'bm_bgm.mp3'
  },
  bgImg: {
    name: 'pb_bg.jpg'
  }
}

/**
 * 返回背景图片链接
 * @param returnUrlEvenNoBackgroundImage 默认即使没有背景图片也返回链接
 */
export function getBgImgUrl(
  returnUrlEvenNoBackgroundImage = true
): string | void {
  const bgConfig = bgScript.getScript(gameIframe.gamePlay, false)
  if (bgConfig && bgConfig.bgUrl) return bgConfig.bgUrl
  if (returnUrlEvenNoBackgroundImage) {
    // 不同制作规范的包存储 bgm 的位置不一样
    if (store.state.workspace.project.isNormMaterialWithSceneSpec) {
      return `${pathConfig.COMMON_PATH}/${resources.bgImg.name}`
    }
    return `${pathConfig.TEXTURE_BASIC_PATH}${resources.bgImg.name}`
  }
}

/**
 * 返回背景图片 bin 链接
 * @param returnUrlEvenNoBackgroundImage 默认即使没有背景图片也返回链接
 */
export function getBgImgBinUrl(
  returnUrlEvenNoBackgroundImage = true
): string | void {
  const url = getBgImgUrl(returnUrlEvenNoBackgroundImage)
  if (url) {
    return url.replace(/\.(png|jpg|jpeg)$/, '.bin')
  }
}

/**
 * 返回背景音乐链接
 * @param returnUrlEvenNoBgm 默认即使没有背景音乐也返回链接
 */
export function getBgmAudioUrl(returnUrlEvenNoBgm = true): string | void {
  const bgConfig = bgScript.getScript(gameIframe.gamePlay, false)
  if (bgConfig && bgConfig.bgmAudioUrl) return bgConfig.bgmAudioUrl
  if (returnUrlEvenNoBgm) {
    // 不同制作规范的包存储 bgm 的位置不一样
    if (store.state.workspace.project.isNormMaterialWithSceneSpec) {
      return `${pathConfig.COMMON_PATH}audio/${resources.bgm.name}`
    }
    return `${pathConfig.AUDIO_BASIC_PATH}${resources.bgm.name}`
  }
}
